import styled from 'styled-components';
import RoundResultsStyled, {
  ResultDefList,
  ResultDD,
  ResultDT,
} from '../RoundResults/RoundResults.styled';

export const GameOverStyled = styled(RoundResultsStyled)`
  height: 60%;
  min-height: 280px;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    height: 50%;
    min-height: 340px;
    min-width: 320px;
    width: 40%;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    width: 35%;
  }
`;

export const GameOverDefList = styled(ResultDefList)`
  display: flex;
  margin: 0 auto 20px;
  max-width: 180px;
  width: 100%;

  dd:nth-child(2),
  dd:nth-child(3) {
    border-bottom: none;
  }
`;

export const GameOverDT = styled(ResultDT)`
  &:first-of-type {
    border-bottom: none;
  }
`;

export const GameOverDD = styled(ResultDD)`
  border-left: none;
`;

export const GameOverText = styled.p`
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.1vmin);
  margin: 30px auto 20px;
  max-width: 300px;
  padding: 0 10px;
  text-transform: uppercase;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 0 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/organisms/GameOver/GameOver.styled.js